import { useMemo } from 'react';

import { useGetInsuredDetailsLovs } from '../amendment.slice';

export function useInsuredDetailsLovs() {
  const { data: lovsData } = useGetInsuredDetailsLovs();

  const nationalities = lovsData?.core?.getNationalities ?? [];
  const occupationClasses = lovsData?.core?.getOccupationClass ?? [];

  const genderOptions = useMemo<Record<string, string>>(
    () => ({
      MALE: 'Male',
      FEMALE: 'Female'
    }),
    []
  );

  const nationalityOptions = useMemo<Record<string, string>>(
    () =>
      nationalities.reduce(
        (acc, n) => {
          if (n?.id && n?.title) acc[n.id] = n.title;

          return acc;
        },
        {} as Record<string, string>
      ),
    [nationalities]
  );

  const occupationClassOptions = useMemo<Record<string, string>>(
    () =>
      occupationClasses.reduce(
        (acc, oc) => {
          if (oc?.id && oc?.title) acc[oc.id] = oc.title;

          return acc;
        },
        {} as Record<string, string>
      ),
    [occupationClasses]
  );

  return { genderOptions, nationalityOptions, occupationClassOptions };
}
